module.exports = __webpack_public_path__ + "static/media/pw.78aaead2.svg";